module.exports = __webpack_public_path__ + "fad52227f846ed82d6815391fa8ec7b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plane-icon.png
// module id = 818
// module chunks = 0